/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');
var modelGet = require('common/util/modelGet');
var LicenseHeaderBarView = require('../../common/views/LicenseHeaderBarView');

var LicenseOfficeManagerChangeApplication = require('../forms/LicenseOfficeManagerChangeApplication');

var tmplLicenseOfficeManagerChangeFormView = require('../templates/LicenseOfficeManagerChangeFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplLicenseOfficeManagerChangeFormView,

  className: 'license-office-manager-change-form-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    licenseOfficeManagerChangeFormContainer: '.license-office-manager-change-form-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    licenseOfficeManagerChangeFormContainer: '@ui.licenseOfficeManagerChangeFormContainer'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId'),
      licenseId = this.model.get('licenseId'),
      licenseContacts = this.model.get('licenseContacts'),
      entityName = modelGet(this.model, 'entityIdentifiers.entityName'),
      licenseType = modelGet(this.model, 'licenseIdentifiers.licenseType'),
      licenseNumber = modelGet(this.model, 'licenseIdentifiers.licenseNumber'),
      officeManager = modelGet(this.model, 'officeManager');

    this.showChildView(
      'headerBarContainer',
      new LicenseHeaderBarView({
        model: new Backbone.Model(this.model.get('licenseIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#ext/nondep/dashboard'
          },
          {
            text: entityName,
            link: '#ext/nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber + ' - ' + licenseType,
            link: '#ext/nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Apply to Edit Branch Manager'
          }
        ]
      })
    );

    this.showChildView(
      'licenseOfficeManagerChangeFormContainer',
      new LicenseOfficeManagerChangeApplication({
        viewMode: this.options.viewMode,
        model: new Backbone.Model({
          licenseContacts: licenseContacts,
          entityId: entityId,
          licenseId: licenseId,
          officeManager: officeManager
        })
      })
    );

    Radio.channel('nd:submit-application').on('submit', function() {
      Radio.channel('navigate').trigger('show:ext:nd:license-dashboard', entityId, licenseId);
    });
  }
});
